import * as React from 'react';
import { Alert, Button, Col, Modal, Row } from 'react-bootstrap';
import { Translate } from '../../../../../shared/LanguageService';
import { IImageThumbnail } from '../Entities';
import Draggable from 'react-draggable';

interface IProps {
    leftImage: IImageThumbnail;
    rightImage: IImageThumbnail;
    isCreating: boolean;

    create: (leftOffset: number, rightOffset: number) => void;
    close: () => void;
}

interface IState {
    leftOffset: number;
    rightOffset: number;
    leftBoundY: number;
    rightBoundY: number;
}

class CreateStitchedImageModal extends React.Component<IProps, IState> {
    // These values comes from old code (DoubleImage.aspx.cs)
    private spacerWidth: number = 6;
    private previewHeight: number = 400;
    private previewWidth: number = 297;

    private isDragging: boolean = false;

    constructor(props: IProps) {
        super(props);

        this.state = {
            leftOffset: 0,
            rightOffset: 0,
            leftBoundY:
                this.props.leftImage.highResolutionHeight /
                    (this.props.leftImage.highResolutionWidth / this.previewWidth) -
                this.previewHeight,
            rightBoundY:
                this.props.rightImage.highResolutionHeight /
                    (this.props.rightImage.highResolutionWidth / this.previewWidth) -
                this.previewHeight
        };

        this.create = this.create.bind(this);
    }

    create() {
        let leftRatio = this.props.leftImage.highResolutionWidth / this.previewWidth;
        let rightRatio = this.props.rightImage.highResolutionWidth / this.previewWidth;
        this.props.create(
            this.state.leftOffset * leftRatio * -1,
            this.state.rightOffset * rightRatio * -1
        );
    }

    render() {
        const { apiUrl } = window.appConfig;

        return (
            <Modal show={true} onHide={this.props.close}>
                <Modal.Header closeButton>
                    <Modal.Title className="pull-left">
                        {Translate('image-processing/stitch-images/modal/title')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Alert bsStyle="info">
                                {Translate('image-processing/stitch-images/modal/info')}
                            </Alert>
                        </Col>
                    </Row>
                    <Row className="tabular column">
                        <Col md={12} className="landscape fixed centered">
                            <div
                                className="stitched-image"
                                style={{
                                    width: this.previewWidth + 'px',
                                    height: this.previewHeight + 'px'
                                }}
                            >
                                <Draggable
                                    axis="y"
                                    bounds={{
                                        left: 0,
                                        top: -this.state.leftBoundY,
                                        right: 0,
                                        bottom: 0
                                    }}
                                    defaultPosition={{ x: 0, y: 0 }}
                                    onStop={(e, ui) =>
                                        this.setState({
                                            leftOffset: ui.y
                                        } as IState)
                                    }
                                >
                                    <img
                                        width={this.previewWidth}
                                        draggable={false}
                                        src={`${apiUrl}/file/${this.props.leftImage.highResolutionImageReference}`}
                                    />
                                </Draggable>
                            </div>
                            <div
                                className="preview-spacer"
                                style={{
                                    width: this.spacerWidth + 'px',
                                    height: this.previewHeight + 'px'
                                }}
                            ></div>
                            <div
                                className="stitched-image"
                                style={{
                                    width: this.previewWidth + 'px',
                                    height: this.previewHeight + 'px'
                                }}
                            >
                                <Draggable
                                    axis="y"
                                    bounds={{
                                        left: 0,
                                        top: -this.state.rightBoundY,
                                        right: 0,
                                        bottom: 0
                                    }}
                                    defaultPosition={{ x: 0, y: 0 }}
                                    onStop={(e, ui) =>
                                        this.setState({
                                            rightOffset: ui.y
                                        } as IState)
                                    }
                                >
                                    <img
                                        width={this.previewWidth}
                                        draggable={false}
                                        src={`${apiUrl}/file/${this.props.rightImage.highResolutionImageReference}`}
                                    />
                                </Draggable>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.close} disabled={this.props.isCreating}>
                        {Translate('image-processing/stitch-images/modal/cancel')}
                    </Button>
                    <Button
                        bsStyle="success"
                        onClick={this.create}
                        disabled={this.props.isCreating}
                    >
                        {this.props.isCreating && <i className="load-spin-dark"></i>}{' '}
                        {Translate('image-processing/stitch-images/modal/create')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default CreateStitchedImageModal;
